import { render, staticRenderFns } from "./ProductionCost.vue?vue&type=template&id=f8505b8a"
import script from "./ProductionCost.vue?vue&type=script&lang=js"
export * from "./ProductionCost.vue?vue&type=script&lang=js"
import style0 from "./ProductionCost.vue?vue&type=style&index=0&id=f8505b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports